<template>
  <main class="main">
    <div class="main_con">
      <div class="review_con">
        <div class="sec_1">
          <p>{{ shopName }}과의 <br />상담은 어떠셨나요?</p>
          <div class="score" :data-score="review.rating">
            <ul>
              <li
                :class="[{ on: i <= review.rating }]"
                v-for="i in 5"
                :key="i"
                @click="setStar(i)"
              ></li>
            </ul>
          </div>
        </div>
        <div class="sec_2">
          <p>어떤 상담을 하셨나요?</p>
          <div class="checkbox">
            <input
              type="checkbox"
              id="internet_cb"
              :true-value="1"
              :false-value="0"
              v-model="review.reviewInternet"
            />
            <label for="internet_cb">인터넷</label>
            <input
              type="checkbox"
              id="mobile_cb"
              :true-value="1"
              :false-value="0"
              v-model="review.reviewMobile"
            />
            <label for="mobile_cb">휴대폰</label>
            <input
              type="checkbox"
              id="visit_cb"
              :true-value="1"
              :false-value="0"
              v-model="review.reviewVisit"
            />
            <label fot="visit_cb">매장방문</label>
            <input
              type="checkbox"
              id="normal_cb"
              :true-value="1"
              :false-value="0"
              v-model="review.reviewNormal"
            />
            <label for="normal_cb">일반</label>
          </div>
        </div>
        <div class="sec_3">
          <textarea
            :placeholder="
              '다른 고객들이 참고 할 수 있도록 상담후기를 공유해주세요!'
            "
            maxlength="300"
            v-model.trim="review.comment"
          />
          <div class="img_upload_list">
            <ul class="img_upload_list_ul">
              <li
                class="img_upload_list_li"
                v-for="(item, index) in review.images"
                :key="index"
              >
                <div class="thumb">
                  <div class="inner">
                    <img v-if="item.src" :src="item.src" />
                    <button
                      class="btn_delete"
                      @click.stop="removeReviewImage(index)"
                    >
                      <i class="i_x_w"></i>
                    </button>
                  </div>
                </div>
              </li>
              <li
                class="img_upload_list_li"
                @click="onClickImageUpload"
                v-if="review.images.length < 3"
              >
                <div class="thumb">
                  <div class="inner">
                    <i class="i_x_w"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <input
            ref="imageInput"
            accept="image/*"
            type="file"
            hidden
            @change="onChangeImages"
          />
        </div>
        <div class="sec_4" v-if="review.reviewInternet > 0">
          <div class="sample_wrap">
            <div class="sample_txt">
              <div class="txt_1">설치 인증 사진을 등록해 보세요!</div>
              <div class="txt_2">
                실제 설치된 현장 사진은 리뷰의 신뢰도를 높힐 수 있어요!
              </div>
            </div>
            <div class="sample_img">
              <img
                :src="
                  require(`@/assets/front/images/new/img_review_sample.png`)
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btm_btn">
      <button
        class="btn"
        @click="saveReview"
        :disabled="review.comment.length < 1"
      >
        등록하기
      </button>
    </div>
    <transition name="fade">
      <div class="made_toast_layer_common" style="top:85%;" v-if="isViewToast">
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
    <DesignPopup2
      :show="openDesignPopup"
      :data="popupParams"
      @close="confirm"
    />
  </main>
</template>

<script>
import { authGetters, authMapGetters } from '@common/store/modules';
import { mapActions as reviewMapActions } from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import DesignPopup2 from '@/common/components/modal/DesignPopup2.vue';

import { handleFile } from '@common/lib/common/imgUtils';

export default {
  name: 'write-review',
  description: '리뷰 작성페이지',
  components: {
    DesignPopup2,
  },
  data() {
    return {
      shopId: this.$route.params.id,
      shopName: '',
      type: this.$route.query.type,
      routeFrom: false,
      review: {
        rating: 5,
        comment: '',
        images: [],
        reviewMobile: 0,
        reviewVisit: 0,
        reviewInternet: 0,
        reviewNormal: 0,
      },
      imageFiles: [],
      isViewToast: false,
      errorMessage: '',
      openDesignPopup: false,
      popupParams: {
        type: 'confirm',
        msg: '',
      },
    };
  },
  async created() {
    if (this.type === 'normal') {
      this.review.reviewNormal = 1;
    } else if (this.type === 'mobile') {
      this.review.reviewMobile = 1;
    } else if (this.type === 'internet') {
      this.review.reviewInternet = 1;
    }

    await this[shopTypes.FETCH_SHOP]({ id: this.shopId }).then(() => {
      this.shopName = this.shop.name;
    });
  },
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      if (from.name === 'InternetCommerce.GuaranteeConfirm') {
        await vm.fetch();
      }
    });
  },
  computed: {
    ...authMapGetters({
      curUser: authGetters.CURRENT_USER,
    }),
    ...shopMapGetters({ shop: shopTypes.SHOP }),
  },
  methods: {
    ...reviewMapActions([reviewTypes.CREATE_REVIEW]),
    ...shopMapActions([shopTypes.FETCH_SHOP]),
    fetch() {
      this.routeFrom = true;
    },
    setStar(point) {
      this.review.rating = point;
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
    saveReview() {
      if (
        !this.review.reviewMobile &&
        !this.review.reviewVisit &&
        !this.review.reviewInternet &&
        !this.review.reviewNormal
      ) {
        this.errorMessage = '상담타입을 선택해주세요.';
        this.toastView();
        return;
      }
      this.popupParams = {
        type: 'confirm',
        msg: '후기를 저장 하시겠습니까?',
      };
      this.openDesignPopup = true;
    },
    async confirm(isSave) {
      if (isSave) {
        // 저장하기 위해 신규 이미지파일들 바이너리 배열로 만들기
        let reviewImageFile = [];
        for (const i in this.imageFiles) {
          if (
            this.imageFiles[i].id === undefined &&
            this.imageFiles[i].fileName !== '' &&
            typeof this.imageFiles[i] === 'object'
          ) {
            let imageFile = this.imageFiles[i].fileItem.blob;

            reviewImageFile.push(imageFile);
          }
        }

        let params = [
          { name: 'visible', value: true },
          { name: 'storeId', value: this.shopId },
          { name: 'userId', value: this.curUser.id },
        ];

        for (const [key, value] of Object.entries(this.review)) {
          if (key !== 'images') {
            params.push({ name: key, value: value });
          }
        }
        console.log('params:: {}', params);

        let payload = new FormData();
        for (const i in params) {
          payload.append(params[i].name.toString(), params[i].value);
        }

        if (reviewImageFile.length > 0) {
          for (const i in reviewImageFile) {
            payload.append('attachfile', reviewImageFile[i]);
          }
        }

        console.log(payload);

        await this[reviewTypes.CREATE_REVIEW](payload);
        this.popupParams = {
          type: 'alert',
          msg: '후기가 저장 되었습니다',
        };
      } else {
        this.openDesignPopup = false;
        if (this.routeFrom) {
          this.$router.push({
            name: 'Apply.Main',
          });
        } else {
          if (this.popupParams.type === 'alert') {
            this.$router.go(-1);
          }
        }
      }
    },
    onClickImageUpload() {
      this.$refs.imageInput.click();
    },
    removeReviewImage(index) {
      this.review.images.splice(index, 1);
      this.imageFiles.splice(index, 1);
    },
    async onChangeImages(e) {
      const maxWidth = 1024,
        quality = 0.92,
        enableCompress = true;
      this.file = null;

      if (e.target.files[0]) {
        const file = e.target.files[0];
        const doSquash = file.type === 'image/jpeg';
        return handleFile(
          file,
          {
            maxWidth,
            quality,
            enableCompress,
          },
          doSquash,
        ).then(blob => {
          const blobURL = URL.createObjectURL(blob);
          const fileItem = {
            url: blobURL,
            blob,
          };
          for (let key in file) {
            if (['slice', 'webkitRelativePath'].indexOf(key) === -1) {
              fileItem[key] = file[key];
            }
          }
          this.file = fileItem;

          this.imageFiles.push({
            fileName: this.file.name,
            fileType: this.file.type,
            fileThumb: blobURL,
            fileItem: fileItem,
          });

          this.review.images.push({ src: blobURL });
        });
      } else {
        this.imageFiles.fileThumb = '';
        this.file = null;
      }
    },
  },
};
</script>

<style></style>
